<template>
  <a-layout id="components-layout-demo-fixed">
    <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%',padding: '0 30px', }" class="nav-bg">
      <my-header></my-header>
    </a-layout-header>
    <a-layout-content :style="{ marginTop: '64px' }">
      <div :style="{ background: '#fff',  minHeight: '380px' }">
        <my-view></my-view>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import MyView from './myView'
import MyHeader from './template/myHeader'

export default {
    data() {
      return {};
    },
    components: {
      MyView,
      MyHeader,
    },
    watch:{
    },
    mounted () {},
    methods:{}
};
</script>
<style>
#components-layout-demo-fixed .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 24px 16px 0;
  float: left;
}
</style>
